module.exports = __webpack_public_path__ + "static/media/unloaded.2d5a0294.svg";